import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { hot } from "react-hot-loader";
import DateRangeControlCell from "./DateRangeControlCell";
import DragSensorCells from "./DragSensorCells";
import JobpackInfo from "./JobpackInfo";
import EventsContainer from "./EventsContainer";
import Fullscreen from "react-fullscreen-crossbrowser";
import moment from "moment";

import {
    getUsers,
    getJobpacks,
    setClickedEventSegment,
    initialise,
    getIsLocked,
    setIsLocked
} from "./actions";
import {
    selectWeekCount,
    selectWeekDayStrings,
    selectIsLocked
} from "./selectors";
import { Button } from "@material-ui/core";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";

const TimelineContainer = styled.div`
    grid-row: 1;
    grid-column: 1;
    width: 100%;
    height: 100%;
    display: grid;
    overflow: hidden;
    grid-template-rows: 30px 1fr;
    grid-template-columns: 130px 1fr;
    background-color: #0188cc;
    border: 2px solid #0188cc;
    border-radius: 4px;
    margin-bottom: 10px;
`;

const SidebarContainer = styled.div`
    grid-row: 2;
    grid-column: 1;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-rows: 50px 50px 1fr;
    grid-template-columns: 1fr;
    justify-content: center;
`;

const LockButtonContainer = styled.div`
    grid-row: 1;
    grid-column: 1;
    color: white;
    padding: 10px;
`;

const FullscreenButtonContainer = styled.div`
    grid-row: 2;
    grid-column: 1;
    color: white;
    padding: 10px;
`;

const StyledButton = styled(Button)`
    && {
        width: 100%;
    }
`;

const DateCellContainer = styled.div`
    width: 100%;
    height: 100%;
    display: grid;
    overflow: hidden;
    grid-template-rows: 1fr;
    grid-template-columns: repeat(${props => props.weekCount * 7}, 1fr);
    background-color: #0188cc;
    border: 2px solid #0188cc;
    border-radius: 4px;
`;

const DateCell = styled.div`
    width: 100%;
    text-align: center;
    padding-top: 2px;
    grid-row-start: 1;
    grid-row-end: 1;
    grid-column-start: ${props => props.day + 1};
    grid-column-end: ${props => props.day + 2};
    background-color: #0188cc;
    color: white;
    border-radius: 4px 4px 0 0;
`;

const DateText = styled.div`
    display: inline-block;
    font-size: 1.1em;
    font-family: "Nunito Sans", -apple-system, ".SFNSText-Regular",
        "San Francisco", BlinkMacSystemFont, "Segoe UI", "Helvetica Neue",
        Helvetica, Arial, sans-serif;
`;
let date = new Date();
let year = moment(date).format("YYYY");
let month = moment(date)
    .format("MMM")
    .toLowerCase();

class RosterV2 extends React.Component {
    constructor(props) {
        super(props);
        props.getUsers();
        props.getJobpacks(year, month);
        props.getIsLocked();
        this.state = {
            isFull: false
        };
    }

    onMouseUp = () => {
        this.props.setClickedEventSegment(false);
    };

    render() {
        const duration = 300;

        return (
            <>
            <Fullscreen
                enabled={this.state.isFull}
                onChange={isFull => this.setState({ isFull })}
            >
                <div className="full-screenable-node">
                    <div isFull={this.state.isFull} style={{height:"100vh"}}>
                        <TimelineContainer
                            weekCount={this.props.weekCount}
                            onMouseUp={this.onMouseUp}
                        >
                            <SidebarContainer>
                                <FullscreenButtonContainer>
                                    <StyledButton
                                        size="small"
                                        variant="outlined"
                                        color="inherit"
                                        onClick={() => {
                                            this.setState({
                                                isFull: !this.state.isFull
                                            });
                                        }}
                                    >
                                        {(this.state.isFull && (
                                            <>Exit Fullscreen</>
                                        )) || <>Enter Fullscreen</>}
                                    </StyledButton>
                                </FullscreenButtonContainer>
                                <LockButtonContainer>
                                    <StyledButton
                                        size="small"
                                        variant="outlined"
                                        color="inherit"
                                        onClick={() => {
                                            this.props.setIsLocked(
                                                !this.props.isLocked
                                            );
                                        }}
                                    >
                                        {(!this.props.isLocked && (
                                            <>
                                                <LockOpenIcon />
                                                Unlocked
                                            </>
                                        )) || (
                                            <>
                                                <LockIcon />
                                                Locked
                                            </>
                                        )}
                                    </StyledButton>
                                </LockButtonContainer>
                            </SidebarContainer>
                            <DateRangeControlCell />
                            <DateCellContainer weekCount={this.props.weekCount}>
                                {Array.isArray(this.props.weekDayStrings) &&
                                    this.props.weekDayStrings.map((e, i) => {
                                        return (
                                            <DateCell key={i} day={i}>
                                                <DateText
                                                    weekCount={
                                                        this.props.weekCount
                                                    }
                                                >
                                                    {e}
                                                </DateText>
                                            </DateCell>
                                        );
                                    })}
                            </DateCellContainer>

                            <EventsContainer
                                duration={duration}
                                weekCount={this.props.weekCount}
                            />
                            <DragSensorCells
                                duration={duration}
                                weekCount={this.props.weekCount}
                            />
                        </TimelineContainer>
                        
                        </div>
                    {/* </StyledCardContent> */}
                </div>
            </Fullscreen>
            <div>
            <JobpackInfo />
            </div>
            </>
        );
    }
}

export default hot(module)(
    React.memo(
        connect(
            store => {
                return {
                    weekCount: selectWeekCount(store),
                    weekDayStrings: selectWeekDayStrings(store),
                    isLocked: selectIsLocked(store)
                };
            },
            {
                getUsers,
                getJobpacks,
                setClickedEventSegment,
                initialise,
                getIsLocked,
                setIsLocked
            }
        )(RosterV2)
    )
);


    